import React from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState, useEffect } from 'react'
import { apiCall } from '../../../api/Interactor';
import { numberFormat, numberFormatWithoutSymbol, showToast } from '../../../Utils';
import { NavLink, useNavigate } from 'react-router-dom';

export default function CreateSettlementDialog(props) {
  const navigate = useNavigate();

  let [isOpen, setIsOpen] = useState(false)
  let [jumlahSettlement, setJumlahSettlement] = useState(0)
  let [totalSettlement, setTotalSettlement] = useState(0)
  let [transferFee, setTransferFee] = useState(0)
  let [platformFee, setPlatformFee] = useState(0)

  function closeModal() {
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  const [headers, setHeaders] = useState([
    { label: '', key: 'transaction_date' },
    { label: 'Pilih Semua', key: 'total_payment' },
  ]);

  const [products, setProducts] = useState([]);

  const [selectAll, setSelectAll] = useState(false);

  // Handles selecting or deselecting all checkboxes
  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    let tmpProducts = [...products]
    tmpProducts.forEach((item, index) => {
      tmpProducts[index].checked = newSelectAll
    });
    setProducts(tmpProducts);
    calculateTotalSettlement();
  };

  // Handles individual row checkbox changes
  const handleRowCheckboxChange = (transaction_date) => {
    let tmpProducts = [...products]
    tmpProducts.forEach((item, index) => {
      if (item.transaction_date === transaction_date) {
        tmpProducts[index].checked = !item.checked
      }
    });
    setProducts(tmpProducts);
    calculateTotalSettlement();
  };

  // Calculate the total settlement based on selected products
  const calculateTotalSettlement = () => {
    calculateJumlahSettlement()
  };

  const calculateJumlahSettlement = () => {
    let total = 0;
    products.forEach(product => {
      if (product.checked) {
        total += product.total_payment;
      }
    });
    console.log("total")
    console.log(total)
    if (total > 0) {
      setJumlahSettlement(total);
      setTotalSettlement(total - transferFee - platformFee);
    } else {
      setJumlahSettlement(0);
      setTotalSettlement(0)
    }
  };

  // Check if all products are selected or some are selected (indeterminate state)
  const allSelected = products.every(product => product.checked);
  const indeterminate = products.some(product => product.checked) && !allSelected;

  // Fetch data for settlements
  const getSettlementApi = () => {
    apiCall(
      "POST", process.env.REACT_APP_USER_DAILY_TRANSACTION,
      {},
      (response) => {
        let data = response.data.data.details;
        // Ensure each item has a 'checked' field set to false initially
        data = data.map(item => ({
          ...item,
          checked: false
        }));
        setProducts(data); // Directly set products here
        setTransferFee(response.data.data.transfer_fee)
        setPlatformFee(response.data.data.platform_fee)
      },
      (message) => {
        showToast("Error", "Failed", message);
      }
    );
  };

  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');  // getMonth() is 0-indexed, so we add 1
    const day = String(date.getDate()).padStart(2, '0');  // Adds leading zero if day is less than 10
    return `${year}-${month}-${day}`;
  };

  const getFullCurrentDate = () => {
    const date = new Date();

    // Array of month names in Bahasa Indonesia
    const monthNames = [
      'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
      'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
    ];

    const day = date.getDate();  // Gets the day of the month
    const month = monthNames[date.getMonth()];  // Maps month number to the month name
    const year = date.getFullYear();  // Gets the full year

    return `${day} ${month} ${year}`;  // Returns the formatted date
  };

  const postSettlementApi = () => {
    if(totalSettlement===0){
      return
    }
    let settlement_details_attributes = []
    products.forEach(product => {
      if (product.checked) {
        product.transactions.forEach(transaction => {
          settlement_details_attributes.push({
            service_member_book_id: transaction.id,
            order_id: transaction.order_id,
            amount: transaction.total_payment,
          });
        });
      }
    });
    apiCall(
      "POST", process.env.REACT_APP_USER_SETTLEMENT,
      {
        settlement_date: getCurrentDate(),
        admin_fee: transferFee,
        platform_fee: platformFee,
        notes: `Settlement tanggal ${getFullCurrentDate()}`,
        settlement_details_attributes: settlement_details_attributes
      },
      (response) => {
        showToast("Success", "Success", response.data.meta.message)
        setTimeout(() => {
          window.location = '/settlement';
        }, 2000)
      },
      (message) => {
        showToast("Error", "Failed", message);
      }
    );
  };

  useEffect(() => {
    getSettlementApi();
    calculateTotalSettlement();
  }, []);

  // useEffect(() => {
  //   calculateTotalSettlement(); // Recalculate total whenever products change
  // }, [products]);

  return (
    <>
      <button
        onClick={openModal}
        className="cursor-pointer flex w-fit h-10 mr-6 items-center px-8 py-3 text-[10px] font-semibold text-white bg-primaryRed rounded-md ml-auto"
      >
        <img src='/ic-withdraw.svg' className='h-6 mr-2' /> Buat Settlement
      </button>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="flex w-full max-w-screen-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex flex-col w-full">
                    <div className="flex w-full">
                      <div className="w-1/2 flex flex-col mr-4">
                        <p className="text-lg text-gray-800 font-semibold mt-2">Buat Settlement</p>
                        <div className="flex flex-col flex-1 rounded-lg border mt-4 pt-2">
                          <div className="flex flex-row">
                            <img src='ic-money-solid.svg' className='ml-6' />
                            <div className="flex flex-col ml-6">
                              <p className="text-sm mt-4">Total Settlement</p>
                              <p className="text-lg font-bold mt-1">Rp. {numberFormatWithoutSymbol(totalSettlement)}</p>
                            </div>
                          </div>

                          <div className="flex flex-row justify-between w-full px-4 mt-6 font-semibold text-[13px]">
                            <p>Total Transaksi</p>
                            <p>Rp. {numberFormatWithoutSymbol(jumlahSettlement)}</p>
                          </div>
                          <hr className="my-2 border-t border-gray-300 mx-4" />
                          <div className="flex flex-row justify-between w-full px-4 mt font-semibold text-[13px]">
                            <p>Biaya Transfer</p>
                            <p>Rp. {numberFormatWithoutSymbol(transferFee)}</p>
                          </div>
                          <hr className="my-2 border-t border-gray-300 mx-4" />

                          <div className="flex flex-row justify-between w-full px-4 mt font-semibold text-[13px]">
                            <p>Biaya Platform</p>
                            <p>Rp. {numberFormatWithoutSymbol(platformFee)}</p>
                          </div>
                          <hr className="my-2 border-t border-gray-300 mx-4" />

                          <button
                            onClick={postSettlementApi}
                            className="cursor-pointer flex items-center justify-center h-10 px-8 text-[10px] font-semibold text-white bg-primaryRed rounded-md mx-4 mt-6"
                          >
                            <img
                              src="/ic-withdraw.svg"
                              className="h-6 mr-2"
                              alt="Withdraw icon"
                            />
                            Buat Settlement
                          </button>

                          <div className="flex mx-4 mt-6 mb-6">
                            <img src="ic-round-info-button.svg" />
                            <p className="text-[10px] ml-2">
                              Proses penarikan dana biasanya memerlukan waktu x hari kerja. Silakan
                              lakukan pengecekan rekening anda secara berkala
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={closeModal}
                          className="cursor-pointer flex h-10 px-8 py-3 text-[10px] font-semibold text-primaryRed bg-white border border-primaryRed rounded-md mt-4 justify-center"
                        >
                          Batalkan
                        </button>
                      </div>
                      <div className="flex w-1/2">
                        {products.length > 0 && <>
                          <div className="w-full h-[300px] overflow-y-auto"> {/* Scrollable tbody */}
                            <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg">
                              <thead className="text-xs text-gray-700 sticky top-0 bg-white z-10 ">
                                <tr>
                                  <th>
                                    <div className="flex flex-1 justify-end items-center mr-4">
                                      <p className="text-right font-bold m-2">Pilih semua</p>
                                      <input
                                        id="checkbox-all-search"
                                        type="checkbox"
                                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                        ref={(el) => {
                                          if (el) {
                                            el.indeterminate = indeterminate;
                                          }
                                        }}
                                      />
                                      <label htmlFor="checkbox-all-search" className="sr-only">checkbox</label>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {products.map((product) => (
                                  <tr key={product.transaction_date} className="bg-white">
                                    <td className="">
                                      <div className="flex flex-1 rounded-lg border bg-white mt-2 px-4 py-2">
                                        {/* Left aligned, centered vertically */}
                                        <div className="flex items-center justify-start flex-1">
                                          <p className="font-semibold text-xs">{product.transaction_date}</p>
                                        </div>

                                        {/* Right aligned content */}
                                        <div className="flex items-center justify-end">
                                          <div className="flex flex-col items-end mr-2">
                                            <div className="text-right text-xs">Total Transaksi</div>
                                            <div className="text-right  font-bold text-sm">Rp. {numberFormatWithoutSymbol(product.total_payment)}</div>
                                          </div>
                                          <input
                                            id={`checkbox-table-${product.transaction_date}`}
                                            type="checkbox"
                                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            checked={product.checked}
                                            onChange={() => handleRowCheckboxChange(product.transaction_date)}
                                          />
                                          <label htmlFor={`checkbox-table-${product.transaction_date}`} className="sr-only">checkbox</label>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>}
                        {
                          (products.length === 0 && <>
                            <div className='w-full'>
                              <div className="flex flex-col items-center justify-center rounded-lg border bg-white mt-[50px] flex-1 h-wrap">
                                <img src="ic-empty-no-transaction.svg" className="mt-6 w-[102px]" />
                                <p className="text-[#b0b0b0] text-center mt-[26px] mb-[49px] text-[13px]">
                                  Transaksi belum tersedia, atau sedang dalam<br />proses Settlement
                                </p>
                              </div>
                            </div>

                          </>)
                        }
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
